import React from "react";
import themePropTypes from "../theme-prop-types";

const CarouselControls = ({
  buttonPrevClassName,
  togglePrev,
  controlsAriaPrevious,
  buttonNextClassName,
  toggleNext,
  controlsAriaNext,
  carouselCounterLabel
}) => (
  <div className='carouselControls'>
    <button
      className={buttonPrevClassName}
      type='button'
      onClick={togglePrev}
      aria-label={controlsAriaPrevious}
    />
    <p className='carouselCounterLabel'>{carouselCounterLabel}</p>
    <button
      className={buttonNextClassName}
      type='button'
      onClick={toggleNext}
      aria-label={controlsAriaNext}
    />
  </div>
);

CarouselControls.propTypes = themePropTypes.carouselControls;

export default CarouselControls;
